import { NgModule } from '@angular/core';

import { HeatingPlanComponent } from './heating-plan.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    HeatingPlanComponent
  ],
  imports: [
    CommonModule,MaterialModule,FormsModule
  ],
  exports:[
    HeatingPlanComponent
  ]
})
export class HeatingPlanModule { }
